/**
 * Created by jonas on 2022-06-15.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {CollectableView} from "./subviews/CollectableView";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap, TimelineLite} from "gsap";
import {KitchenDramaSushiMania} from "../KitchenDramaSushiMania";
import {KitchenDramaSushiManiaGameAssets} from "../KitchenDramaSushiManiaGameAssets";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";

export class KamisabiCollectView extends PIXI.Container implements StageLayer {
    private collectables: CollectableView[];
    private logo: TimelineSprite;
    private view: PIXI.Container;
    private _kamisabiLogo: TimelineSprite;

    constructor() {
        super();
        this.name = "KamisabiCollectView";
        this.init();
    }

    onResize(): void {

        if (NolimitApplication.isLandscape) {
            this.view.scale.set(1, 1);
            this.view.position.set(850, 85);
            this.logo.position.set(0, 0);

            this.collectables[0].position.set(0, 125);
            this.collectables[1].position.set(0, 280);
            this.collectables[2].position.set(0, 435);

            this.view.addChild(this.collectables[0]);
            this.view.addChild(this.collectables[1]);
            this.view.addChild(this.collectables[2]);

        } else {
            this.view.scale.set(0.8, 0.8);
            this.view.position.set(520, 45);
            this.logo.position.set(0, 0);

            this.collectables[0].position.set(-110, -70);
            this.collectables[1].position.set(110, -70);
            this.collectables[2].position.set(0, -90);

            this.view.addChild(this.collectables[0]);
            this.view.addChild(this.collectables[1]);
            this.view.addChild(this.collectables[2]);
        }

        this.view.addChild(this.logo);

    }

    public updateCollected(count: number): gsap.core.Timeline {
        const tl = gsap.timeline();
        count = Math.min(count, this.collectables.length);
        for (let i: number = 0; i < count; i++) {
            if (!this.collectables[i].isCollected) {
                tl.add(this.collectables[i].collect(), "<0.2");
            }
        }
        if (count === 3) {
            tl.add(this.playKamisabiLogoAnim());
        }
        return tl;
    }

    public resetAll(): gsap.core.Timeline {
        const tl = gsap.timeline();
        for (let i: number = 0; i < this.collectables.length; i++) {
            if (this.collectables[i].isCollected) {
                tl.add(this.collectables[i].reset());
            }
        }
        return tl;
    }

    public playWinAnimation(): gsap.core.Timeline {
        const tl = gsap.timeline();
        for (let i: number = 0; i < this.collectables.length; i++) {
            tl.add(this.collectables[i].playWin(), "<0.2");
        }
        return tl;
    }

    public playWinReset(): gsap.core.Timeline {
        const tl = gsap.timeline();
        for (let i: number = 0; i < this.collectables.length; i++) {
            tl.add(this.collectables[i].playWinReset(), "<0.2");
        }
        return tl;
    }

    public show() {
        this.view.visible = true;
    }

    public hide() {
        this.view.visible = false;
    }

    public stopKamisabiLogoAnim(): void {
        this._kamisabiLogo.hide();
        this._kamisabiLogo.stopLoop();
        this._kamisabiLogo.removeChild();
    }

    private init() {
        this.view = new PIXI.Container();
        this.addChild(this.view);

        this._kamisabiLogo = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures("kamisabiLogo"));
        this._kamisabiLogo.anchor.set(0.5, 0.5);
        this._kamisabiLogo.position.set(0);
        this._kamisabiLogo.hide();

        this.collectables = [
            new CollectableView("ka"),
            new CollectableView("mi"),
            new CollectableView("sabi")
        ];

        this.logo = new TimelineSprite(KitchenDramaSushiMania.assetLoader.getTextures(KitchenDramaSushiManiaGameAssets.KAMISABI_LOGO));
        this.logo.setFrame(0);
        this.logo.anchor.set(0.5, 0.5);

        this.onResize();

    }

    private playKamisabiLogoAnim(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        this.view.addChild(this._kamisabiLogo);
        tl.add(() => {
            this._kamisabiLogo.show();
            this._kamisabiLogo.playLoop();
        });
        return tl;
    }
}